<template>
  <div class="page">
    <div class="card pb20" v-if="!isPriceImport">
      <p class="f16">{{ $t('common.tip') }}</p>
      <p class="mt10">{{ $t('product.importTip1') }}</p>
      <p class="mt10">{{ $t('product.importTip2') }}</p>
      <p class="mt10">
        {{ $t('product.importTip31') }}
        <el-link type="primary" @click="downloadTemplateDesc">{{ $t('product.importTip32') }}</el-link>
        {{ $t('product.importTip33') }}
      </p>
    </div>

    <div class="card pb20">
      <p class="f16 mb10">{{ $t('product.importFile') }}</p>
      <div class="upload-container">
        <div class="upload-btn">
          <el-button type="primary" icon="el-icon-upload" plain>{{ $t('product.uploadFile') }}</el-button>
          <input @change="changeFile" accept=".csv" type="file" />
        </div>
        <el-button type="text" @click="downloadTemplate">{{ $t('common.download', [' ']) }}{{ $t('common.template') }}</el-button>
      </div>
      <p class="mt10 gray">{{ $t('product.supportSuffix', ['.csv']) }}</p>
      <div class="file-item bg-gray" v-if="selectFileName"><i class="el-icon-document"></i> {{ selectFileName }}</div>
      <div class="mt20">
        <el-button v-if="isPriceImport" class="mt20 mb20" type="primary" @click="submitUpload(3)">{{ $t('product.batchPriceImport') }}</el-button>
        <template v-else>
          <el-button class="mb10" type="primary" @click="submitUpload(1)" v-if="updateAllBtn">{{ $t('product.allUpdate') }}</el-button>
          <el-button type="primary" @click="submitUpload(2)">{{ $t('product.someUpdate') }}</el-button>
        </template>
      </div>
    </div>

    <el-table class="spacing-table" v-loading="loading" :data="tableData">
      <el-table-column :label="$t('common.taskName')" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.data.eventType === 'product_delta_update' ? $t('product.importSome') : $t('product.importAll') }}
        </template>
      </el-table-column>
      <el-table-column prop="wholesaleNo" :label="$t('product.wholesaleNo')" min-width="150" v-if="vendorType == 7"></el-table-column>
      <el-table-column prop="allUpdate" :label="$t('product.isAllUpdate')" min-width="150" v-if="vendorType == 7">
        <template slot-scope="scope">
          <span>{{ scope.row.allUpdate ? $t('product.fullUpdate') : $t('product.IncrementalUpdate') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" :label="$t('common.startDate')" min-width="150"></el-table-column>
      <el-table-column :label="$t('common.status')">
        <template slot-scope="scope">
          <span
            :class="{
              green: scope.row.status === 'Success' || scope.row.status === '成功',
              red: scope.row.status === 'Failed' || scope.row.status === '失败',
            }"
            >{{ scope.row.status }}</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="fileReport" :label="$t('product.fileReport')" min-width="200"></el-table-column>
      <el-table-column :label="$t('common.result')" min-width="150">
        <template slot-scope="scope">
          <template v-if="scope.row.data.total != undefined"> total {{ scope.row.data.total }}, </template>
          <template v-if="scope.row.data.total != undefined && scope.row.data.failedCount != undefined">
            success: {{ scope.row.data.total - scope.row.data.failedCount }},
          </template>
          <template v-if="scope.row.data.failedCount != undefined"> Faild: {{ scope.row.data.failedCount }} </template>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.wasteTime')" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.costTime != null ? scope.row.costTime / 1000 + $t('common.s') : '' }}
        </template>
      </el-table-column>
      <el-table-column width="250" :label="$t('common.action')">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            v-if="scope.row.status !== '导入中' && scope.row.status !== 'Importing' && scope.row.data.importUrl"
            @click="downloadResult(scope.row.data.importUrl)"
            >Import File</el-button
          >
          <el-button
            type="primary"
            size="small"
            v-if="scope.row.status !== '导入中' && scope.row.status !== 'Importing' && scope.row.data.resultUrl"
            @click="downloadResult(scope.row.data.resultUrl)"
            >{{ $t('common.download', [' ']) }}{{ $t('common.result') }}</el-button
          >
          <el-button type="primary" size="small" v-if="scope.row.twiceConfirm" @click="twiceConfirm(scope.row.taskManageId)">{{
            $t('common.twiceConfirm')
          }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
    <el-dialog :title="$t('common.tip')" :visible.sync="dialogVisible" width="400px">
      <div style="padding-bottom: 10px">{{ $t('product.updateOnlyItems') }}</div>
      <el-form inline>
        <el-form-item :label="$t('product.wholesaleNo')" :rules="[{ required: true }]">
          <el-select clearable filterable v-model="wholesaleNo" style="width: 100%">
            <el-option v-for="item in codeList" :key="item.wholesaleNo" :label="item.wholesaleNo" :value="item.wholesaleNo"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('product.updateType')" :rules="[{ required: true }]">
          <el-select clearable filterable v-model="allUpdate" style="width: 100%">
            <el-option v-for="item in allUpdateList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submit">{{ $t('common.ok') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  importOrExportManagerTask,
  uploadProductAllUpdate,
  uploadProductSomeUpdate,
  uploadProductSomeUpdateSeven,
  productImportTemplate,
  batchPriceImport,
  getPriceImportTemplate,
  importTwiceConfirm,
  getWholesaleValidList,
} from '../../api/product';
import { downloadUrlFile, createCSVFile } from '../../common/utils';
import { getUserInfo } from "../../api/system"

function checkPermission(list, code) {
  for (let i = 0; i < list.length; i++) {
    const menu = list[i];
    if (menu.code.endsWith('product_manager')) {
      for (let j = 0; j < menu.children.length; j++) {
        const sub = menu.children[j];
        if (sub.code === 'new_import_product') {
          for (let k = 0; k < sub.children.length; k++) {
            const element = sub.children[k];
            if (element.code === code) {
              return true;
            }
          }
        }
      }
    }
  }
  return false;
}
export default {
  name: 'ProductImport',
  data() {
    return {
      isPriceImport: this.$route.path === '/product/price/import',
      loading: false,
      queryForm: {
        pageNo: 1,
        pageSize: 25,
      },
      total: 0,
      tableData: [],
      selectFileName: '',
      dialogVisible: false,
      codeList: [],
      wholesaleNo: null,
      allUpdate: null,
      allUpdateList: [
        {
          label: '全量更新',
          value: true,
        },
        {
          label: '增量更新',
          value: false,
        },
      ],
    };
  },
  created() {
    this.getTableData();
    getUserInfo().then((res) => {
      if (res && res.data) {
        if(res.data.vendorType === 7){
          this.getWholesaleValidList()
        }
      }
    });
  },
  computed: mapState({
    // 店铺是否支持CO   0 不支持 1 支持
    showIsCo: (state) => state.userinfo.coFlag === 1,
    updateAllBtn: (state) => checkPermission(state.menuList, 'all_product_update'),
    showNewD: (state) => state.userinfo.vendorType === 7,
    vendorType: (state) => state.userinfo.vendorType,
  }),
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.daterange = [];
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      let taskCode = 'portal_excel_import_product';
      if (this.isPriceImport) {
        taskCode = 'portal_excel_import_update_price';
      }
      importOrExportManagerTask({
        ...this.queryForm,
        taskCode,
      }).then((res) => {
        this.total = res.data.total || 0;
        this.tableData = (res.data.list || []).map((item) => {
          try {
            item.data = JSON.parse(item.data);
            item.fileReport = item.data.fileReport;
          } catch (error) {
            // nothing
          }
          return item;
        });
        this.loading = false;
      });
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    downloadResult(url) {
      downloadUrlFile(url);
    },
    twiceConfirm(taskId) {
      this.$confirm(this.$t('common.twiceConfirmTip'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirmImport'),
        cancelButtonText: this.$t('common.importExit'),
        type: 'warning',
      })
        .then((res) => {
          importTwiceConfirm({
            taskId,
            isAgree: true,
          }).then((res) => {
            if (res && res.success) {
              this.$message.success(this.$t('error.successful'));
            } else {
              this.$message.info(res.data.message);
            }
            this.getTableData();
          });
        })
        .catch((res) => {
          importTwiceConfirm({
            taskId,
            isAgree: false,
          }).then((res) => {
            if (res && res.success) {
              this.$message.success(this.$t('error.successful'));
            } else {
              this.$message.info(res.data.message);
            }
            this.getTableData();
          });
        });
    },
    downloadTemplateDesc() {
      downloadUrlFile(
        this.showIsCo
          ? 'https://product-sts.oss-cn-shanghai.aliyuncs.com/tmp/%E5%95%86%E5%93%81%E6%A8%A1%E6%9D%BF%E8%AF%B4%E6%98%8E%20Template%20Description.xlsx'
          : 'https://sha-oss-static.oss-cn-shanghai.aliyuncs.com/upload/%E5%95%86%E5%93%81%E6%A8%A1%E6%9D%BF%E8%AF%B4%E6%98%8E%20Template%20Description.xlsx?v=0615'
      );
    },
    changeFile(e) {
      if (e && e.target && e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        if (!/\.csv$/.test(String(file.name).toLowerCase())) {
          this.$message.error(this.$t('product.supportSuffix', ['.csv']));
        } else if (file.size > 50 * 1024 * 1024) {
          this.$message.error(this.$t('product.fileTooLarge'));
        } else {
          this.selectFileName = file.name;
          this.selectFile = file;
        }
      }
      e.target.value = '';
    },
    submitUpload(type) {
      if (!this.selectFile) {
        this.$message('请选择文件');
        return;
      }
      let message = this.$t('product.willBeCleared');
      if (type === 2) {
        message = this.$t('product.updateOnlyItems');
        if (this.showNewD) {
          this.dialogVisible = true;
          this.wholesaleNo = null;
          this.allUpdate = null;
          return;
        }
      } else if (type === 3) {
        message = this.$t('product.batchPriceImportTip');
      }
      this.$msgbox({
        title: this.$t('common.tip'),
        message,
        showCancelButton: true,
        confirmButtonText: this.$t('common.ok'),
        cancelButtonText: this.$t('common.cancel'),
      }).then(() => {
        const formData = new FormData();
        formData.append('file', this.selectFile);
        let request = uploadProductAllUpdate;
        if (type === 2) {
          request = uploadProductSomeUpdate;
        } else if (type === 3) {
          request = batchPriceImport;
        }
        request(formData).then((res) => {
          if (res.code === '1' || res.code === 1) {
            this.$message.error(this.$t('product.importingLater'));
            this.getTableData();
            return;
          }
          if (res.code === '3' || res.code === 3) {
            this.$message.error(res.message);
            this.getTableData();
            return;
          }
          this.selectFileName = '';
          this.selectFile = null;
          this.getTableData();
        });
      });
    },
    downloadTemplate() {
      if (this.isPriceImport) {
        getPriceImportTemplate().then((res) => {
          if (res.data) {
            this.downloadResult(res.data);
          }
        });
      } else {
        productImportTemplate().then((res) => {
          if (res.success) {
            createCSVFile(res.data.join(','), 'template.csv');
          } else {
            this.$message.error(res.message || this.$t('error.systemerror'));
          }
        });
      }
    },
    getWholesaleValidList() {
      this.loading = true;
      getWholesaleValidList().then((res) => {
        this.codeList = res.data || [];
        this.loading = false;
      });
    },
    submit() {
      if (!this.wholesaleNo) {
        this.$message.error(this.$t('common.plzSelect') + this.$t('product.wholesaleNo'));
        return;
      }
      if (this.allUpdate === null || this.allUpdate === '') {
        this.$message.error(this.$t('common.plzSelect') + this.$t('product.updateType'));
        return;
      }
      const formData = new FormData();
      formData.append('file', this.selectFile);
      if (this.showNewD) {
        uploadProductSomeUpdateSeven(formData, '?wholesaleNo=' + this.wholesaleNo + '&allUpdate=' + this.allUpdate).then((res) => {
          if (res.code === '1' || res.code === 1) {
            this.$message.error(this.$t('product.importingLater'));
            this.getTableData();
            return;
          }
          if (res.code === '3' || res.code === 3) {
            this.$message.error(res.message);
            this.getTableData();
            return;
          }
          this.dialogVisible = false;
          this.selectFileName = '';
          this.selectFile = null;
          this.getTableData();
        });
      } else {
        formData.append('wholesaleNo', this.wholesaleNo);
        formData.append('allUpdate', this.allUpdate);
        uploadProductSomeUpdate(formData).then((res) => {
          if (res.code === '1' || res.code === 1) {
            this.$message.error(this.$t('product.importingLater'));
            this.getTableData();
            return;
          }
          if (res.code === '3' || res.code === 3) {
            this.$message.error(res.message);
            this.getTableData();
            return;
          }
          this.dialogVisible = false;
          this.selectFileName = '';
          this.selectFile = null;
          this.getTableData();
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-container {
  display: flex;

  .upload-btn {
    position: relative;
    margin-right: 50px;

    input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
}
.file-item {
  display: inline-block;
  padding: 5px 10px;
  margin-top: 10px;
  border-radius: 4px;
}
</style>
